// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-o_gc","advertDetailContactGroup__header":"c-o_ge","advertDetailContactGroup__value":"c-o_gf"};